/* eslint-disable max-len */
import PropTypes from 'prop-types'
import { controlFlagsPropType } from './control-flags-prop-type'

/**
 * @typedef {Object} GlobalControlFlags
 * @property {ControlFlags} [controlFlags]      - The list of all granted flags and UI features. Use the name as key with 'uiFeatureLimits' in order to check if there are limits on the UI feature.
 * @property {Object}       [uiFeatureLimits]   - The list of UI features with constraints.
 */

export const globalControlFlagsPropType = PropTypes.shape({
    controlFlags: controlFlagsPropType,
    uiFeatureLimits: PropTypes.object // eslint-disable-line react/forbid-prop-types
})

// There is no further type specification of 'uiFeatureLimits' in the Swagger doc of WASAPI.
